<template>
 <el-button 
    @click="$emit('click')" 
    class="base-button"
    :loading="loading"
    v-bind="$attrs"
  >
    <div v-if="!loading" class="d-flex align-center justify-center">
      <slot name="prefix" />
      <slot />
      <slot name="suffix" />
    </div>
  </el-button>
</template>

<script>
export default {
  name: "BaseButton",
  props: { 
    loading: { default: false }
  }
}
</script>

<style lang="scss" scoped>
.base-button {
  font-size: 20px;
  font-weight: 700;
  border-radius: 6px;
  border: none;

  +.el-button {
    margin-left: 0;
  }

  // &:disabled {
  //   color: var(--color-gray75) !important;
  //   background-color: var(--color-gray95) !important;
  // }
}
</style>


// WEBPACK FOOTER //
// src/baseComponents/button/BaseButton.vue